<template>
<v-col cols="12" v-if="view==='side'">
    <a class="nav-link nav-link--danger" @click="signout">
        <span class="icon-badge">
            <v-icon size="20">mdi-exit-to-app</v-icon>
        </span>
        <span class="ml-3 mr-3 nav-text">Signout</span>
    </a>
</v-col>
<a class="nav-link" @click="signout" title="Signout" v-else>
    <v-icon size="20px">mdi-exit-to-app</v-icon>
</a>
</template>

<script>
  export default {
    name: 'SignOut',
    props: [
        'view'
    ],
    methods: {
        signout () {
            sessionStorage.removeItem('authToken')
            localStorage.removeItem('school')
            sessionStorage.removeItem('utpc')
            sessionStorage.removeItem('accessToken')
            sessionStorage.removeItem('loggedUser')
            this.$store.commit("isLoggedIn", false);
            this.$store.commit("isTokenAccess", false);
            this.$router.push({name: 'Login'})
        }
    }
  }
</script>
<style scoped>
.icon-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.75);
    transition: background-color 0.2s ease, color 0.2s ease;
}
.nav-link{
    text-decoration: none;
    color: rgba(255, 255, 255, 0.75) !important;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.92rem;
    transition: background-color 0.2s ease, color 0.2s ease;
    cursor: pointer;
}
.nav-link--danger:hover{
    background-color: rgba(230, 74, 25, 0.14);
    color: #FF8A65 !important;
}
.nav-link--danger:hover .icon-badge{
    background: rgba(230, 74, 25, 0.22);
    color: #FF8A65;
}
.nav-link--danger:hover .nav-text{
    color: #FF8A65 !important;
}
a.nav-link[title="Signout"]{
    color: #44546E !important;
    padding: 0;
    display: inline-flex;
    cursor: pointer;
}
a.nav-link[title="Signout"]:hover{
    color: #E64A19 !important;
    background-color: transparent;
}
</style>
